<template>
    <div id="app-next" />
</template>

<script>
import { startExistFunction } from 'utils/startExistFunction';

export default {
    methods: {
        init() {
            startExistFunction('initNextReact', 50);
        },

        reset() {
            startExistFunction('resetNextReact', 50);
        },
    },

    mounted() {
        this.init();
    },

    beforeUnmount() {
        this.reset();
    },
};
</script>
